interface Props {
  label: string;
  value: string;
}

export const PreviouslyTooltipItem = ({ label, value }: Props) => (
  <div className="body-5">
    <span className="text-neutral-80">{label}:</span> {value}
  </div>
);
